// import { StrictMode } from "react";
// gatsbyjs.com/docs/reference/built-in-components/gatsby-script/
import React from 'react';
import RootElement from './src/components/RootElement';
require('./src/styles/global.scss');

const { TRACKING_LIBS } = require('./src/utils/analytics/constants');
const { isBot, appendScript, defineHubspotContentType } = require('./src/utils/analytics/index');

const SALESLOFT_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJ0IjoxMDIzNTR9.R-Ox19gaSwGtYEXWTIu1O14uQ6x_ZbD3Mfcd2yu-I9s';

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};

export const onClientEntry = () => {
  if (isBot()) return;
  
  // Hubspot SPA - Step 1: Set up the path for the initial page view
  // https://developers.hubspot.com/docs/reference/api/analytics-and-events/tracking-code#tracking-in-single-page-applications
  const pathname = window?.location.pathname || '';
  const contentType = defineHubspotContentType(pathname);
  
  let _hsq = window._hsq = window._hsq || [];
  _hsq.push(['setContentType', contentType]);
  _hsq.push(['setPath', pathname]);
  
  appendScript(TRACKING_LIBS.GoogleTagManager);

  // Salesloft web tracking (page views)
  window['SLScoutObject'] = 'slscout';
  window.slscout = window.slscout || function() { (window.slscout.q = window.slscout.q || []).push(arguments); };
  window.slscout.l = +new Date();
  appendScript('https://scout-cdn.salesloft.com/sl.js');
  window.slscout(['init', SALESLOFT_TOKEN]);
};

export const onInitialClientRender = () => {
  if (isBot()) return;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (isBot()) return;
  if (!prevLocation) return;
  
  // Hubspot SPA - Step 2: Tracking subsequent page views
  // timeout is needed to wait for document.title
  setTimeout(() => {
    const pathname = location?.pathname || window?.location.pathname;
    const contentType = defineHubspotContentType(pathname);

    let _hsq = window._hsq = window._hsq || [];
    _hsq.push(['setContentType', contentType]);
    _hsq.push(['setPath', pathname]);
    _hsq.push(['trackPageView']);
  }, 500);
};